/**
 * Fired on `document` the first time AppComponent has something to show.
 *
 * Shared between the Angular app (which dispatches it) and the AEM launcher (which listens for it
 * to drop its placeholder). The launcher used to guess with `setTimeout(…, 1500)`, which races the
 * app's actual bootstrap - on a slow load, or one that fails outright, the placeholder was dropped
 * while `<app-root>` was still empty.
 */
export const APP_READY_EVENT = 'rbmaz:app-ready';
